import { ConfigOption } from '@ngx-formly/core';
import { ShippingMethodDropDownComponent } from './controls/shipping-method-drop-down/shipping-method-drop-down.component';
import { FormlyShippingMethodAddressLinkWidgetComponent } from './widgets/formly-shipping-method-address-link-widget/formly-shipping-method-address-link-widget.component';

export const SHIPPING_METHOD_FORMLY_TYPES: ConfigOption['types'] = [
  { name: 'formly-shipping-method-drop-down', component: ShippingMethodDropDownComponent, wrappers: ['simple-title'] },
  { name: 'formly-shipping-method-address-link', component: FormlyShippingMethodAddressLinkWidgetComponent, wrappers: ['simple-title'] },
]
